import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";
import { IApiError } from "ui/shared/models/common";

export interface IReleaseDetailsResponse {
  releaseId: string;
  status: string;
  name: string;
}

export interface IReleaseChangeData {
  id: string;
  version: number;
}

export interface IReleaseDetailsResponseError {
  entityId: string;
  error: IApiError;
}

export interface IReleaseUpdateRequest {
  addedMessages: IReleaseChangeData[];
  deletedMessages: IReleaseChangeData[];
  addedTerms: IReleaseChangeData[];
  deletedTerms: IReleaseChangeData[];
}

export interface ITerm {
  termId: string;
  term: string;
  definition: string;
  version: number;
}

export interface ITermData {
  term: ITerm;
  status: Status;
  validationIssues: IValidationIssue[];
}

export enum Status {
  Initial = 0,
  Added = 1,
  Deleted = 2
}

export interface IMessage {
  messageId: string;
  text: string;
  parentMessage: string;
  isParentMessage: boolean;
  version: number;
}

export interface IMessageData {
  message: IMessage;
  status: Status;
  validationIssues: IValidationIssue[];
}

export interface IReleaseDetailsState {
  releaseId: string;
  releaseName: string;
  releaseStatus: string;
  isLoading: boolean;
  shouldRedirect?: boolean;
  textValidationError: string;
  notifications: INotification[];
  termsPickerData: ITerm[];
  associatedTerms: ITermData[];
  selectedAssociatedTerms: ITermData[];
  newStagedTerm: ITerm[];
  messagesPickerData: IMessage[];
  associatedMessages: IMessageData[];
  selectedAssociatedMessages: IMessageData[];
  newMessages: IMessage[];
}

export const getReleaseDetailsInitialState = (): IReleaseDetailsState => {
  return {
    releaseId: "",
    releaseName: "",
    releaseStatus: "",
    isLoading: false,
    shouldRedirect: false,
    notifications: [],
    textValidationError: "",
    termsPickerData: [],
    associatedTerms: [],
    selectedAssociatedTerms: [],
    newStagedTerm: [],
    associatedMessages: [],
    messagesPickerData: [],
    selectedAssociatedMessages: [],
    newMessages: []
  };
};
